// export default Projects;
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AtomicSpinner from 'atomic-spinner'
import { useSelector, useDispatch } from 'react-redux';
import { fetchProjects } from './redux/actions/projectsActions';

const Projects = () => {
  const projects = useSelector(state => state.projects);
  const dispatch = useDispatch();

  useEffect(() => {
    if (projects.length === 0) {
      dispatch(fetchProjects());
    }
    console.log(projects)

  }, [dispatch, projects]);

  return (
    <div className="team" id="projects">
      <h2 className="main-title">Freelance</h2>
      {projects.length === 0 ? (
        <div className="heading">
          <h1 className="heading">Loading Freelance Projects</h1>
          <AtomicSpinner />
        </div>
      ) : (
        <div className="container">
          {projects
            .filter((project) => project.jobType === "Remote Job") // Filter projects by jobType
            .map((project) => (
              <div className="box" key={project.id}>
                <div className="data">
                  <Link to={`/task/${project._id}`} state={{ pro: `${project._id}` }}>
                    <img
                      src={require(`../../../portfolio-backend/NewImages/${project.name}/${project._id}_0.png`)}
                      alt=""
                    />
                  </Link>
                  <div className="social">
                    <a href="#">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="#">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="#">
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                    <a href="#">
                      <i className="fab fa-youtube"></i>
                    </a>
                    <a
                      href="https://github.com/mohamedabi17"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="youtube"
                    >
                      <i className="fa fa-github"></i>
                    </a>
                  </div>
                </div>
                <div className="info">
                  <h3>{project.name}</h3>
                  <p>{project.description}</p>
                  <div className='specification'>
                  <p><a className='med_button' target='_blank' href={project.projectLink}>Preview</a></p>
                  <p>{project.jobType}</p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
  
};

export default Projects;